module.exports = __webpack_public_path__ + "media/images/athletes/1694-25d4a551cf31f14ecbdc6275157a88ac.png";